import {CreateDirectories, createFileListItem, gaEvent, gaException, isSafeFile, safeFilename, Utf8ArrayToStr, utf8Decode, pause} from './Utils'  // eslint-disable-line

//import {Archive} from 'libarchive.js' // eslint-disable-line
import DropboxService from './DropboxService' // eslint-disable-line



// https://github.com/use-strict/7z-wasm


export default class _7ZService {
    archiveFileName = null;
    worker;
    processing = false;
    
    fileList;
    fileListError;
    extractedFile;
    extractedFileError;

    directories = new Set();    
    filter;
    unfilteredCount;    
    dbxService;
    encrypted = false;
    password;
    extractor;

    constructor(archiveFile, filter) {
        this.archiveFileName = archiveFile.name;
        let isTar = false;
        // TODO: this could be bit better... 
        
        ['tar.gz', 'tgz', 'tar.bz2', 'tbz2','tbz', 'tar.xz', 'txz', 'tar.lz', 'tlz', 'tar.z' ].forEach(ext => {            
            if (this.archiveFileName.toLowerCase().indexOf(ext) > -1) {
                isTar = true;
            }
        })        
        this.filter = filter;
        // PROD worker
        this.worker = new Worker('/assets/szw-19092022/w.js');
        
        // DEV worker
        //this.worker = new Worker('/assets/szw-19092022/worker.js');


        this.worker.onmessage = msg => {
                
            switch (msg.data.type) {
                case 'fileList': {
                    let rawFileList = msg.data.fileList;                    
                    this.encrypted = msg.data.encrypted;
                    this.setFileList(rawFileList);                                 
                    break;
                } 
                case 'fileListError': {
                    console.log(msg.data.error);
                    gaException('worker-fileListError|' + this.archiveFileName + '|' + JSON.stringify(msg.data.error));
                    this.fileListError = msg.data.error;                    
                    break;
                }
                case 'extractFile': {
                    //console.log(msg.data);
                    this.extractedFile = msg.data.file;                    
                    break;
                }
                case 'extractFileError': {
                    console.log(msg.data);
                    gaException('worker-extractFileError|' + this.archiveFileName + '|' + JSON.stringify(msg.data.error));
                    this.extractedFileError = msg.data.error;                    
                    break;
                }
            }
            this.processing = false;            
        };

        this.processing = true;
        this.worker.postMessage({
            method: 'setArchiveFile',
            archiveFile,
            isTar,
            filter
        });                
    }


    isEncrypted() {
        return this.encrypted;
    }

    getUnfilteredCount() {
        return this.unfilteredCount;
    }

    async setPassword(password) {
        this.password = password;
        return this.getFileList(true);
    }

    getFileList() {
       const checkFileList = (resolve, reject) => {  
            setTimeout(() => {
                if(this.fileList) {
                    resolve(this.fileList);
                } else if (this.fileListError) {                    
                    reject(this.fileListError);
                } else {
                    checkFileList(resolve, reject); // check again after a second...
                }
            }, 100);                
       }    
                  
        return new Promise((resolve, reject) => {
            return checkFileList(resolve, reject);
        }); 
    }

    setFileList(rawFileList) {
        let fileCount = 0;
        let _fileList = new Set();
        rawFileList.forEach(f => {                        
            if (isSafeFile(f.filename) && !(f.fullpath.indexOf('__MACOSX') > -1)) {
                const ext = f.fullpath.split('.').pop().toUpperCase();                                
                
                if(!this.filter || ext.toUpperCase().indexOf(this.filter.toUpperCase()) > -1) {
                    let _filename =  utf8Decode(f.fullpath); 
                    _fileList.add(createFileListItem(_filename, f.isDirectory, f.size));
                }
                this.unfilteredCount = fileCount; 
                if (!f.isDirectory) {
                    fileCount++;
                }                
            }            
        });
        this.unfilteredCount = fileCount;
        this.fileList = _fileList;
    }
    
    extractFile(filename) {      
        if (this.processing) {
            return new Promise((resolve, reject) => {
                reject('Busy processing previous request');
            });
        }
        this.extractedFile = null;
        this.extractedFileError = null;

        // Call the worker...
        this.processing = true;
        this.worker.postMessage({
            method: 'extractFile',
            filename,
            password: this.password            
        });
        
        const checkExtractFile = (resolve, reject) => {  
            setTimeout(() => {
                if(this.extractedFile) {
                    resolve(this.extractedFile);
                } else if (this.extractedFileError) {                    
                    reject(this.extractedFileError);
                } else {
                    checkExtractFile(resolve, reject); // check again after a second...
                }
            }, 30);                
       }    
                  
        return new Promise((resolve, reject) => {
            return checkExtractFile(resolve, reject);
        });
    }

    async saveAll(outputDir, progressUpdateFn) {
        if (outputDir === '') {
            console.log("No output directory selected, please select an output directory first");
            return;
        }
        console.log('SaveAll zip');
        let writer;
        let fileCounter = 0;
        let totalFiles = this.unfilteredCount;
        let unallowedFiles = [];
        for (const file of this.fileList) {
            
            
            const ext = file.fullpath.split('.').pop();

            if (file.fullpath.indexOf('__MACOSX') > -1) { // Ignore these...
                continue;
            }
            if (file.isDirectory) {
                continue;
            }
            
            if (isSafeFile(file.fullpath) && (!this.filter || ext.indexOf(this.filter) > -1) ) {
                //console.log(file.file._path)
                const filePath = safeFilename(file.fullpath); 
                //console.log('filepath='+filePath+'|');               
                const [dir, fileName] = await CreateDirectories(outputDir, filePath);
                            
                let exists;  // eslint-disable-line
                try {
                    'getFile' in dir ? await dir.getFile(fileName, {create: false}) : await dir.getFileHandle(fileName, {create: false});
                    exists = true;
                } catch(e) {
                    // Continue.
                    exists = false;
                }
                try {
                    const outputFile = 'getFile' in dir ? await dir.getFile(fileName, {create: true}) : await dir.getFileHandle(fileName, {create: true});                
                    
                    progressUpdateFn({currentFile: filePath, progress: (fileCounter/totalFiles)*100 }); // TODO: Maybe check to see that this is a function?
                    writer = await outputFile.createWritable({keepExistingData: false});                     
                    let blob = await this.extractFile(file.fullpath);
                    const stream = blob.stream();
                    await stream.pipeTo(writer);
                } catch (ex) {                   
                    if(ex.message && ex.message.indexOf('Name is not allowed') > -1) {                    
                        console.log(ex);                    
                        unallowedFiles.push(file);
                        gaEvent('name-not-allowed-warning', filePath);
                    } else if(ex.message && ex.message.indexOf('Safe Browsing')) {
                        console.log(ex);                    
                        unallowedFiles.push(file);
                        gaEvent('extractor-name-not-allowed2-warning', filePath);
                    } else {
                        console.log('ex', filePath);                        
                        throw ex;
                    }
                }
                fileCounter++;
            }            
        }
        return {unallowedFiles};
    }

    async saveFileToDropbox(fullpath) {        
        if(!this.dbxService) {
            this.dbxService = new DropboxService();
        }
        
        let blob = await this.extractFile(fullpath);
        // Individual files aren't saved with full path...        
        let name = safeFilename(fullpath.split('/').pop());        
        return this.dbxService.uploadFile(name, blob); 
    }


    async saveAllToDropbox(progressUpdateFn) {
        if(!this.dbxService) {
            this.dbxService = new DropboxService();
        }
        
        let fileCounter = 0;
        let totalFiles = this.fileList.size; // WARNING: This might not always be the total count!!!
        let unallowedFiles = [];
        for (const file of this.fileList) {
            
            
            const ext = file.fullpath.split('.').pop();

            if (file.fullpath.indexOf('__MACOSX') > -1) { // Ignore these...
                continue;
            }
            if (file.isDirectory) {
                continue;
            }
            
            if (isSafeFile(file.fullpath) && (!this.filter || ext.indexOf(this.filter) > -1) ) {
                let blob = await this.extractFile(file.fullpath); 
                const filePath = safeFilename(file.filename);
                progressUpdateFn({currentFile: filePath, progress: fileCounter === 0? 0 : (fileCounter/totalFiles)*100 });
                await this.dbxService.uploadFile(filePath, blob);
                fileCounter++;
            }            
        }
        return {unallowedFiles};
    }



    
    

    
}